// extracted by mini-css-extract-plugin
export default {"other-fee-div":"OtherFee_other-fee-div__KDWd4","other-fee-div2":"OtherFee_other-fee-div2__7XS42","acc-collpse":"OtherFee_acc-collpse__w-Tnc","fee-input":"OtherFee_fee-input__TjR+t"};